module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-1-Article-w540.93473625.webp";